var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechGenericProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_3_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.3,345.1c-23.8,0-43.2,19.4-43.2,43.2s19.4,43.2,43.2,43.2c23.8,0,43.2-19.4,43.2-43.2 S144.1,345.1,120.3,345.1z M120.3,414.3c-14.3,0-25.9-11.6-25.9-25.9s11.6-25.9,25.9-25.9c14.3,0,25.9,11.6,25.9,25.9 S134.6,414.3,120.3,414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.9,345.1c-23.8,0-43.2,19.4-43.2,43.2s19.4,43.2,43.2,43.2c23.8,0,43.2-19.4,43.2-43.2 S446.8,345.1,422.9,345.1z M422.9,414.3c-14.3,0-25.9-11.6-25.9-25.9s11.6-25.9,25.9-25.9c14.3,0,25.9,11.6,25.9,25.9 S437.2,414.3,422.9,414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M267.3,345.1c-23.8,0-43.2,19.4-43.2,43.2s19.4,43.2,43.2,43.2c23.8,0,43.2-19.4,43.2-43.2 S291.1,345.1,267.3,345.1z M267.3,414.3c-14.3,0-25.9-11.6-25.9-25.9s11.6-25.9,25.9-25.9c14.3,0,25.9,11.6,25.9,25.9 S281.6,414.3,267.3,414.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "neutral_5_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111.7,310.5c-42.9,0-77.8,34.9-77.8,77.8c0,42.9,34.9,77.8,77.8,77.8h354.5v-17.3H111.7 c-33.4,0-60.5-27.2-60.5-60.5s27.2-60.5,60.5-60.5h354.5v-17.3H111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.8,68.4h-95.1c-11.9,0-21.6,9.7-21.6,21.6c0,11.9,9.7,21.6,21.6,21.6h95.1c11.9,0,21.6-9.7,21.6-21.6 C336.5,78.1,326.8,68.4,314.8,68.4z M314.8,94.4h-95.1c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3h95.1c2.4,0,4.3,1.9,4.3,4.3 C319.2,92.4,317.2,94.4,314.8,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M422.9,33.9H111.7c-9.5,0-17.3,7.8-17.3,17.3v224.8c0,9.5,7.8,17.3,17.3,17.3h311.2c9.5,0,17.3-7.8,17.3-17.3 V51.1C440.2,41.6,432.4,33.9,422.9,33.9z M422.9,275.9H111.7l0-224.8l311.2,0L422.9,275.9z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechGenericProjects;